import { Col, Form, InputNumber, Switch } from 'antd';
import ErrorHandler from 'common/error/components/error-handler';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import {
  Button,
  Div,
  Flex,
  FormField,
  Row,
  Span,
  notification,
} from 'ui';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { isObjectNullOrEmpty } from '../../../utils/helpers';
import {
  fetchCustomerCenterConfiguration,
  resetConfigurationSuccess,
  updateCustomerCenterConfiguration,
} from '../../containers/customer-center-configuration/customer-center-configuration-actions';

const StyledSaveButton = styled(Button)`
  text-transform: uppercase;
`;

const StyledFormItem = styled(FormField)`
  display: inline-flex;
  .ant-legacy-form-explain {
    max-width: 73px;
  }
`;

const StyledInputNumber = styled(InputNumber)`
  width: 60px;
  padding: 0 !important;
  margin: 0 5px;
  height: 21px !important;
  .ant-input-number-input-wrap {
    height: 20px !important;
    input {
      height: 20px !important;
    }
  }
`;

const StyledSwitch = styled(Switch)`
  vertical-align: baseline;
  margin-left: 10px;
`;

const CustomerCenterConfiguration = ({
  intl,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const {
    configuration = {},
    isLoading,
    saveSuccess,
    error,
  } = useSelector(state => state.customerCenterConfiguration);

  useEffect(() => {
    dispatch(fetchCustomerCenterConfiguration());
  }, []);

  useDeepCompareEffect(() => {
    if (!isObjectNullOrEmpty(configuration)) {
      form.setFieldsValue({
        goodsAvailabilityOffset: configuration.goodsAvailabilityOffset,
        calculateTravelTime: !!configuration.calculateTravelTime,
      });
    }
  }, [configuration]);

  useEffect(() => {
    if (saveSuccess) {
      notification.success({
        message: intl.formatMessage({ id: 'ccConfig.SAVE_SUCCESS' }),
        placement: 'top',
      });
      dispatch(resetConfigurationSuccess());
    }
  }, [saveSuccess]);

  const handleSave = (values) => {
    dispatch(updateCustomerCenterConfiguration(values));
  };

  return (
    <Form
      form={form}
      onFinish={handleSave}
    >
      <Div marginTop={20}>
        <ErrorHandler type='notification' error={error} />
        <Row type='flex' gutter={16} marginRight={0}>
          <Col lg={8} md={8} sm={12} xs={24}>
            <Span>{intl.formatMessage({ id: 'ccConfig.LOGISTICS_ALERT_DESCRIPTION' })}</Span>
            <StyledFormItem
              name='goodsAvailabilityOffset'
              rules={[{
                required: true,
                message: intl.formatMessage({ id: 'ccConfig.errors.DAYS_BEFORE' }),
              }]}
            >
              <StyledInputNumber disabled={isLoading} min={0} max={20} />
            </StyledFormItem>
            <Span>{intl.formatMessage({ id: 'ccConfig.DAYS' })}</Span>
          </Col>
        </Row>
        <Row type='flex' gutter={16} marginRight={0}>
          <Col lg={8} md={8} sm={12} xs={24}>
            <Span>{intl.formatMessage({ id: 'ccConfig.TRAVEL_TIME' })}</Span>
            <StyledFormItem name='calculateTravelTime' valuePropName='checked'>
              <StyledSwitch disabled={isLoading} />
            </StyledFormItem>
          </Col>
        </Row>
        <Flex jcfs marginTop={20}>
          <StyledSaveButton
            type='secondary'
            htmlType='submit'
            disabled={isLoading}
          >
            {intl.formatMessage({ id: 'holidays.SAVE' })}
          </StyledSaveButton>
        </Flex>
      </Div >
    </Form>
  );
};

CustomerCenterConfiguration.propTypes = {
  intl: PropTypes.object,
};

export default injectIntl(CustomerCenterConfiguration);
